import Rails from 'rails-ujs'
import MicroModal from 'micromodal'
import { $1, $, each } from '../util'

const Dashboard = (() => {
  const manageLoadImageProfile = () => {
    const button = $1('.js-dashboard-load-image-profile-button')
    const input = $1('.js-dashboard-load-image-profile-input')
    const submit = $1('.js-dashboard-load-image-profile-submit')
    if (!button || !input || !submit) return

    button.addEventListener('click', (e) => {
      e.preventDefault()
      input.click()
    })

    input.addEventListener('change', (e) => {
      submit.click()
    })
  }

  const manageValidateValidation = () => {
    const buttons = $('.js-dashboard-validate-validation-button')
    if (!buttons || buttons.length < 1) return

    const inputUuid = document.getElementById('modalValidationValidateValidationUuid')

    each(buttons, (_i, button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        inputUuid.value = button.getAttribute('data-validation-uuid')
        MicroModal.show('modalValidationValidate')
      })
    })
  }

  const manageValidatePlayer = () => {
    const buttons = $('.js-dashboard-validate-validation-player')
    if (!buttons || buttons.length < 1) return

    const videoPlayerSource = document.getElementById('modalValidationVideoPlayerSource')

    each(buttons, (_i, button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        videoPlayerSource.src = button.getAttribute('data-source')
        videoPlayerSource.load()
        MicroModal.show('modalValidationVideoPlayer')
      })
    })
  }

  const init = () => {
    manageLoadImageProfile()
    manageValidateValidation()
    manageValidatePlayer()
  }

  return {
    init,
    manageLoadImageProfile,
  }
})()

export default Dashboard



// WEBPACK FOOTER //
// app/javascript/scripts/components/Dashboard.js